import { render, staticRenderFns } from "./clinicalGuidelines.vue?vue&type=template&id=7b201c39&"
import script from "./clinicalGuidelines.vue?vue&type=script&lang=js&"
export * from "./clinicalGuidelines.vue?vue&type=script&lang=js&"
import style0 from "./clinicalGuidelines.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports